import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="bg-gray-900 text-white fixed w-full top-0 z-50 shadow">
      <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
        <NavLink to="/" className="text-xl font-bold text-orange-500">RF FUN SERVER</NavLink>

        {/* Mobile Button */}
        <button onClick={toggleMenu} className="md:hidden">
          {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6 items-center">
          <NavLink to="/" className={({ isActive }) => isActive ? "text-orange-400 font-semibold" : "hover:text-orange-400"}>
            Home
          </NavLink>
          <NavLink to="/guide" className={({ isActive }) => isActive ? "text-orange-400 font-semibold" : "hover:text-orange-400"}>
            Guide
          </NavLink>
          <NavLink to="/community" className={({ isActive }) => isActive ? "text-orange-400 font-semibold" : "hover:text-orange-400"}>
            Community
          </NavLink>
          <NavLink to="/leaderboard" className={({ isActive }) => isActive ? "text-yellow-400 font-semibold" : "hover:text-yellow-400"}>
            🏆 Leaderboard
          </NavLink>
          <NavLink to="/download" className={({ isActive }) => isActive ? "text-orange-400 font-semibold" : "hover:text-orange-400"}>
            Download
          </NavLink>
          <NavLink to="/pitboss-tracker" className={({ isActive }) => isActive ? "text-red-400 font-semibold" : "hover:text-red-400"}>
            👹 Pitboss Tracker
          </NavLink>

          {/* Dropdown */}
          <div className="relative group">
            <button onClick={() => setDropdownOpen(!dropdownOpen)} className="hover:text-orange-400 flex items-center gap-1">
              Lainnya
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-white text-gray-800 rounded shadow z-10">
                <a href="https://funserv.mdev.my.id/" target="_blank" rel="noopener noreferrer" className="block px-4 py-2 hover:bg-orange-100">
                  GameCP/Register
                </a>
                <a href="https://mdev.my.id/" target="_blank" rel="noopener noreferrer" className="block px-4 py-2 hover:bg-orange-100">
                  Market
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-gray-800 px-4 pb-4 space-y-2">
          <NavLink to="/" onClick={closeMenu} className="block hover:text-orange-400">Home</NavLink>
          <NavLink to="/guide" onClick={closeMenu} className="block hover:text-orange-400">Guide</NavLink>
          <NavLink to="/community" onClick={closeMenu} className="block hover:text-orange-400">Community</NavLink>
          <NavLink to="/leaderboard" onClick={closeMenu} className="block hover:text-yellow-400">🏆 Leaderboard</NavLink>
          <NavLink to="/download" onClick={closeMenu} className="block hover:text-orange-400">Download</NavLink>
          <NavLink to="/pitboss-tracker" onClick={closeMenu} className="block hover:text-red-400">👹 Pitboss Tracker</NavLink>
          <div className="pt-2 border-t border-gray-700">
            <p className="text-orange-400 font-semibold">Lainnya</p>
            <a href="https://funserv.mdev.my.id/" target="_blank" rel="noopener noreferrer" className="block pl-4 hover:text-orange-300">
              GameCP/Register
            </a>
            <a href="https://mdev.my.id/" target="_blank" rel="noopener noreferrer" className="block pl-4 hover:text-orange-300">
              Market
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
